import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  leadList: [],
  SFLeadList: []
};

const slice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LEAD LIST
    getLeadListSuccess(state, action) {
      state.isLoading = false;
      state.leadList = action.payload;
    },

    // GET LEAD LIST
    getVehicleLeadSuccess(state, action) {
      state.isLoading = false;
      state.SFLeadList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function getLeadList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query {
        getLeadList
           {
              leadId,
              advertiser,
              customerId,
              date,
              email,
              locationId,
              message,
              name,
              phone,
              requestId,
              stockNo,
              subject,
              vehicleId
           }
      }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getLeadListSuccess(response.data.data.getLeadList)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVehicleLeads(stockNumber) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query { getVehicleLeads(stockNumber: "${stockNumber}") {
        Identifier
        SalesForceLeadId
        UniqueIdentifier
        ItemId
        SellerIdentifier
        Service
        LeadType
        RequestType
        ItemType
        Status
        Comments
        Created
        Modified
        Item { 
            Id
            StockNumber
            Make
            Model
            Badge
            Description
            Year
            Price
            RedbookCode
            RegistrationNumber
            DetailsUrl
        }
        Tags
        Subscription {
            Newsletter
        }
        Prospect {
            FirstName
            LastName
            Postcode
            MobilePhone
        }
        Assignment {
            Email
            Name
            Assigned
        }
        History {
            Id
            Type
            Created
            Note
        }
      } }`;

      const response = await axios.post('/graphql', { query: queryString });

      dispatch(
        slice.actions.getVehicleLeadSuccess(response.data.data.getVehicleLeads)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
